import { render, staticRenderFns } from "./Outflow.vue?vue&type=template&id=1f97c586&scoped=true"
import script from "./Outflow.vue?vue&type=script&lang=js"
export * from "./Outflow.vue?vue&type=script&lang=js"
import style0 from "./Outflow.vue?vue&type=style&index=0&id=1f97c586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f97c586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
